import React, { CSSProperties } from "react";
import { ControlIcons } from "icons/ControlIcons";
import { Colors } from "constants/Colors";
import styled from "styled-components";
import { Tooltip, Classes } from "@blueprintjs/core";
// I honestly can't think of a better name for this enum
export enum Activities {
  HOVERING,
  SELECTED,
  ACTIVE,
  NONE,
}
const StyledTooltip = styled(Tooltip)`
  .${Classes.POPOVER_TARGET} {
    height: 100%;
  }
`;
const SettingsWrapper = styled.div`
  justify-self: flex-end;
  height: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
  left: -5px;
  & {
    pre {
      margin: 0 5px 0 0;
      font-size: ${props => props.theme.fontSizes[3]}px;
      height: ${props => props.theme.fontSizes[3]}px;
      line-height: ${props => props.theme.fontSizes[3] - 1}px;
    }
  }
  border-radius: 2px;
`;

const WidgetName = styled.span`
  margin-left: 5px;
  font-family: Roboto;
  font-size: 12px;
  line-height: 12px;
`;

type SettingsControlProps = {
  toggleSettings: (e: any) => void;
  activity: Activities;
  name: string;
};

const SettingsIcon = ControlIcons.SETTINGS_CONTROL;

const getStyles = (activity: Activities): CSSProperties | undefined => {
  switch (activity) {
    case Activities.ACTIVE:
      return {
        background: "#FFFFFF",
        color: "#6C767E",
      };
    case Activities.HOVERING:
      return {
        background: "#FFFFFF",
        color: "#6C767E",
      };
    case Activities.SELECTED:
      return {
        background: "#FFFFFF",
        color: "#6C767E",
      };
  }
};

export const SettingsControl = (props: SettingsControlProps) => {
  const settingsIcon = (
    <SettingsIcon
      width={12}
      height={14}
      color={props.activity === Activities.HOVERING ? "#3B82FF" : "#3B82FF"}
    />
  );

  return (
    <StyledTooltip
      content="Edit widget properties"
      position="top-right"
      hoverOpenDelay={500}
    >
      <SettingsWrapper
        style={getStyles(props.activity)}
        onClick={props.toggleSettings}
        className="t--widget-propertypane-toggle"
      >
        {settingsIcon}
        <WidgetName className="t--widget-name">{props.name}</WidgetName>
      </SettingsWrapper>
    </StyledTooltip>
  );
};

export default SettingsControl;
